"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenSettings = void 0;

function useOpenSettings() {
  return function () {
    window.open("chrome://settings/content/siteDetails?site=".concat(encodeURIComponent(window.location.origin)), '_blank');
  };
}

exports.useOpenSettings = useOpenSettings;